import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { Calendar, Lock } from "lucide-react";

interface Property {
  id: string;
  title: string;
  shortName?: string;
}

interface CalendarDayOptionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedDate: Date | null;
  selectedProperty: Property | null;
  isDateBlocked: boolean;
  onAddReservation: () => void;
  onBlockDate: () => void;
}

const CalendarDayOptionsModal = ({
  isOpen,
  onClose,
  selectedDate,
  selectedProperty,
  isDateBlocked,
  onAddReservation,
  onBlockDate,
}: CalendarDayOptionsModalProps) => {
  if (!selectedDate || !selectedProperty) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold text-gray-900">
            Opciones del Día
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-5">
          <div className="bg-gray-50 p-4 rounded-lg shadow-sm ring-1 ring-gray-200">
            <h3 className="font-semibold text-gray-900 text-base">
              {format(selectedDate, "EEEE, d MMMM yyyy", { locale: es })}
            </h3>

            <p className="text-sm text-gray-600 mt-0.5">
              {selectedProperty.shortName || selectedProperty.title}
            </p>

            {isDateBlocked && (
              <p className="text-sm text-red-600 mt-2 font-medium">
                ⚠️ Este día está actualmente bloqueado
              </p>
            )}
          </div>

          <div className="space-y-2">
            <Button
              onClick={onAddReservation}
              className="bg-brand-primary hover:bg-brand-primary-hover w-full flex items-center justify-center gap-2"
            >
              <Calendar className="h-4 w-4" />
              Añadir Reserva
            </Button>

            <Button
              onClick={onBlockDate}
              variant="outline"
              className="w-full flex items-center justify-center gap-2 border border-red-300 text-red-700 hover:bg-red-50 hover:border-red-400"
            >
              <Lock className="h-4 w-4" />
              {isDateBlocked ? "Desbloquear Día" : "Bloquear Día"}
            </Button>
          </div>

          <Button
            onClick={onClose}
            variant="ghost"
            className="w-full text-gray-600 hover:text-gray-800"
          >
            Cancelar
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CalendarDayOptionsModal;
